function handleActiveShipping() {
	shippingInitSelect2(undefined, '.js-shipping_options');
	$(".shipping-control.selected").removeClass("selected");
	var shipping_selected = $(".shipping-control input[name=shipping_id]:checked").parents(".shipping-control");
	shipping_selected.addClass("selected");
	shipping_callback = shipping_selected.attr("data-callback");
	if (shipping_callback) {
		try {
			window[shipping_callback]();
		} catch (e) { /* callback undefined */
			console.error("Callback not defined", shipping_callback, e);
		}
	}
}

function handleActivePayment() {
	shippingInitSelect2(undefined, '.js-payment_options');
	$(".payment-control.selected").removeClass("selected");
	var payment_selected = $(".payment-control input[name=payment_id]:checked").parents(".payment-control");
	payment_selected.addClass("selected");
	payment_callback = payment_selected.attr("data-callback");
	if (payment_callback) {
		try {
			window[payment_callback]();
		} catch (e) { /* callback undefined */
			console.error("Callback not defined", payment_callback, e);
		}
	}
}


$(function () {
	if (
		$('.shipping-control.selected').find('input[name=shipping_id]').length > 0 &&
		$('.shipping-control.selected').find('input[name=' + $('.shipping-control.selected').find('input[name=shipping_id]').val() + '_selected]').val() !== ''
	) {
		selectSelectedShipping(
			$('.shipping-control.selected').find('input[name=shipping_id]').val()
		);
	}
	$("#payment_form").on("change", "input[name=shipping_id]", function (e) {
		handleActiveShipping();
	});

	$("#payment_form").on("change", "input[name=payment_id]", function (e) {
		handleActivePayment();
	});

	handleActiveShipping();
	handleActivePayment();
});


function shippingInitSelect2(_parent, where) {
	_parent = _parent || 'body';
	where = $(where || 'body')
	var els = where.find('.js-select2', _parent);
	if (typeof $.fn.select2 !== 'undefined') {
		els.select2({
			dropdownParent: $(_parent),
			language: {
				noResults: function (term) {
					return "Nenalezli jsme žádnou pobočku :("
				}
			}
		});
	}
}


function selectSelectedShipping(id) {
	var selectedChoice = $('input[type=hidden][name="' + id + '_selected"]').val();
}


var add_voucher = function (ev) {
	ev.preventDefault();
	ev.stopPropagation();
	var input = ev.currentTarget;

	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.OPENED) {
			document.body.classList.add("loading");
		} else if (req.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
			document.body.classList.remove("loading");
		}
		else if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var resp = JSON.parse(req.responseText);
				showModal(resp.modal);
			}
			else {
				alert("Chyba");
			}
		}
	};
	var args = {
		voucher_id: input.voucher_code.value
	};

	if (input.voucher_code.value === "") {
		input.voucher_code.classList.add('alert-danger');
	} else {
		input.voucher_code.classList.remove('alert-danger');
		req.open("POST", "/ajax/voucher_use", true);
		req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		// serialize je definovaná v login.js
		req.send(serialize(args));
		return false;
	}
};


function updateBasketSummary(cart) {
	var price_types = ["full_netto", "full_brutto", "discount_brutto", "discounted_brutto"];
	if (cart["items"].length) {
		for (var i = 0; i < cart["items"].length; ++i) {
			var cart_key = cart["items"][i]["ident"] + "*/*" + cart["items"][i]["c_type"] + "*/*" + cart["items"][i]["parent_ident"];
			for (var j in price_types) {
				var price_type = price_types[j];
				var elem = document.querySelector(".js--cart-item[data-key='" + cart_key + "'] .js--price--" + price_type);
				if (elem) {
					elem.innerHTML = format_price(cart["items"][i][price_type]);
				}
			}
		}

		var tot_netto = document.querySelector(".js-total-without-vat");
		if (tot_netto) {
			tot_netto.innerHTML = format_price(cart.pricing.discounted_netto) + "&nbsp;Kč";
		}
		var tot_brutto = document.querySelector(".js-total-with-vat");
		if (tot_brutto) {
			tot_brutto.innerHTML = format_price(cart.pricing.to_pay_for_cart) + "&nbsp;Kč";
		}
	}
}

var change_cart_row = function (ev) {
	ev.preventDefault();
	ev.stopPropagation();
	var input = ev.currentTarget;
	var count = parseInt(input.value);
	var variant = input.dataset.variant;

	var args = {
		"provider": input.dataset.provider,
		"parent_ident": input.dataset.parent_ident,
		"content_type": input.dataset.content_type,
		"count": count,
	};
	if (variant) {
		args["extend_info"] = JSON.stringify({ "variant": variant });
	}

	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.OPENED) {
			document.body.classList.add("loading");
		} else if (req.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
			document.body.classList.remove("loading");
		}
		else if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var response_data = JSON.parse(req.responseText);
				if (response_data.status === 200) {

					updateBadges(response_data.response);
					updateBasketPrice(response_data.response);
					updateBasketSummary(response_data.response);
					updateItemsQuantity(response_data.response);
					$('table.checkout tr.js--cart-item').remove();
					$('table.checkout tr.js--cart-warning').remove();
					$('table.checkout tr.vouchers').remove();
					// tydy byl původně selector 'table.checkout tr.js--cart-header:last-child'
					// ale last-child rozbíjí řádek přihlášení na crew takže vyberu jinak a vyberu poslední prvek
					// pokud by to bylo potřeba zase předělat je potřeba to ověřit
					var tbl = $('table.checkout tr.js--cart-header');
					if (tbl) {
						tbl = tbl.last();
						tbl.after(response_data.vouchers);
						tbl.after(response_data.items);
					}

					initializeScroolToTopWarnings();

					var remove_buttons = document.querySelectorAll(
						".vouchers button.remove-from-cart, .js--cart-item button.remove-from-cart");
					[].forEach.call(remove_buttons, function (item) {
						item.addEventListener("click", handleRemoveFromCart);
					});
					var quantity_inputs = document.querySelectorAll("input[type=number].quantity-counter");
					if (quantity_inputs) {
						[].forEach.call(quantity_inputs, function (item) {
							initialize_quantity_input(item);
						});
					}

					// handle warnings
					var cont_button = $(".js--continue-button");
					var warn_prefix = 'js-button-warning-';
					var errs = [];
					cont_button.each(function (idx, el) {
						for (var i = el.classList.length >>> 0; i--;) {
							var cls = el.classList[i];
							if (cls.substring(0, warn_prefix.length) === warn_prefix) {
								var err = cls.substring(warn_prefix.length);
								if (errs.indexOf(err) === -1) {
									errs.push(err);
								}
							}
						}
					});
					errs.forEach(function (w) {
						cont_button.removeClass(warn_prefix + w);
						$('.js-invisible-' + w).hide();
					});
					if (response_data.warnings) {
						response_data.warnings.forEach(function (w) {
							cont_button.addClass(warn_prefix + w);
							$('.js-invisible-' + w).show();
						});
					}
					bindMeiroTrackClick();
					bindGTMtrackClick();
					runTrackEvent();
					runMeiroTrackEvent();
				}
				else {
					showModal(response_data.modal);
				}
			}
			else {
				alert("Chyba");
			}
		}
	};
	req.open("POST", "/ajax/change_item_quantity", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	// serialize je definovaná v login.js
	req.send(serialize(args));
	return false;
};

function ensureAddressTypes() {
	if (typeof window.firstAddress === 'undefined') {
		window.firstAddress = "facturation";
		window.secondAddress = "shipping";
	}
	if (typeof window.secondAddress === 'undefined') {
		if (window.firstAddress == "facturation") {
			window.secondAddress = 'shipping';
		} else {
			window.secondAddress = "shipping";
		}
	}
}

if (typeof (showOrderOverlay) == 'undefined') {
	// je i ve scripts.js
	function showOrderOverlay() {
		// disable ESC while submitting order
		// vlastne chci odfiltrovat jakykoli stiknuti klavesy
		// nepotrebuji zadnou interakci usera pres klavesy
		window.addEventListener('keydown', function (e) {
			e.preventDefault();
			e.stopPropagation();
			/*
			var charCode = e.charCode || e.keyCode || e.which;
			if (charCode === 27) {
				e.preventDefault();
				return false;
			}
			*/
		});
		if (typeof bootstrap != "undefined") {
			ovModal = new bootstrap.Modal(document.getElementById('modal_loading'), { backdrop: 'static', keyboard: false });
			ovModal.show();
		}
		else {
			$('#modal_loading').modal({ backdrop: 'static', keyboard: false });
		}
	}
}

var check_order_before_submit = function (event) {
	/*
	 * Přihlášený uživatel má adresu v popupu mimo hlavní form - proto se musí kontrolovat samostatně.
	 * */
	var form = event.target;

	if (form) {
		// console.log("start validace");
		var valid = false;
		try {
			valid = checkinputs(form);

			// TODO tohle asi nefunguje protože to nevynucujeme -> tohle bychom ve všech krocích měli dávat jako hidden a jen si to načítat a ne tohle šílenství
			var has_physical = false;
			var items = document.querySelectorAll(".js--checkout--mini .js--checkout");
			for (var c = 0; c < items.length; ++c) {
				if (items[c].dataset.physical.toLowerCase() === "true") {
					has_physical = true;
					break;
				}
			}
			// console.log("has phsical: ", has_physical);

			if (has_physical) {
				//zajistím aby byly nastaveny proměnné first a second address
				ensureAddressTypes();
				// Fyzické zboží vyžaduje validní adresu
				// pokud je prihlaseny uzivatel má adresu mimo formulář a já tedy musím zkontrolovat jestli je adresa validní
				var formFirstAddress = document.querySelector('form[name=change_address].' + window.firstAddress);
				var formFirstFullAddressInput = document.querySelector('input[name=' + window.firstAddress + '_full_address]');
				if (
					typeof (formFirstAddress) !== 'undefined' &&
					document.body.contains(formFirstAddress)
				) {
					if (!is_address_valid(formFirstAddress, window.firstAddress)) {
						$("#modal_edit_" + window.firstAddress + "_address").modal({
							show: true
						});
						valid = false;
					}

					if (form["edit_" + window.secondAddress + "_address"] && form["edit_" + window.secondAddress + "_address"].checked) {
						var formSecondAddress = document.querySelector('form[name=change_address].' + window.secondAddress);
						if (document.body.contains(formSecondAddress)) {
							if (!is_address_valid(formSecondAddress, window.secondAddress)) {
								$("#modal_edit_" + window.secondAddress + "_address").modal({
									show: true
								});
								valid = false;
							}
						}
					}
				} // endif - kontrola adres přihlášeného uživatele
				else if (
					typeof (is_full_address_valid) === 'function' &&
					typeof (formFirstFullAddressInput) !== 'undefined' &&
					document.body.contains(formFirstFullAddressInput)
				) {
					if (!is_full_address_valid(formFirstFullAddressInput.form, window.firstAddress)) {
						valid = false;
						mark_invalid($('input[name="' + window.firstAddress + '_full_address"]')[0], undefined);
						if (!$('input[name="' + window.firstAddress + '_full_address"]').is(':visible') &&
							!$('input[name="' + window.firstAddress + '_street"]').is(':visible')) {
							$('.js--toggle-shpping-data-form').trigger('click');
							$('#formdata').collapse('hide');
							$('#formdataedit').collapse('show');
						}
					}

					if (form["edit_" + window.secondAddress + "_address"] && form["edit_" + window.secondAddress + "_address"].checked) {
						var formSecondAddress = formFirstFullAddressInput.form;
						if (!is_full_address_valid(formSecondAddress, window.secondAddress)) {
							valid = false;
							mark_invalid($('input[name="' + window.secondAddress + '_full_address"]')[0], undefined);
							if (!$('input[name="' + window.secondAddress + '_full_address"]').is(':visible') &&
								!$('input[name="' + window.secondAddress + '_street"]').is(':visible')) {
								$('.js--toggle-shpping-data-form').trigger('click');
								$('#formdata').collapse('hide');
								$('#formdataedit').collapse('show');
							}
						}
					}
				}

			} // has_physical
			else {
				var formSecondFullAddressInput = document.querySelector('input[name=' + window.secondAddress + '_full_address]');
				if (document.body.contains(formSecondFullAddressInput)) {
					var checkBoxEl = $('#add_' + window.secondAddress + '_addressr');
					if (!checkBoxEl.length || checkBoxEl.prop('checked')) {
						var formSecondAddress = formSecondFullAddressInput.form;
						if (!cnc_is_address_valid(formSecondAddress, window.secondAddress)) {
							valid = false;
							mark_invalid($('input[name="' + window.secondAddress + '_full_address"]')[0], undefined);
							if (!$('input[name="' + window.secondAddress + '_full_address"]').is(':visible') &&
								!$('input[name="' + window.secondAddress + '_street"]').is(':visible')) {
								$('.js--toggle-shpping-data-form').trigger('click');
								$('#formdata').collapse('hide');
								$('#formdataedit').collapse('show');
							}
							if ($('#facturation_phone').hasClass('is-invalid')) {
								$('#facturation_phone_needed').collapse('show');
								if (is_address_valid(formSecondAddress, window.secondAddress)) {
									mark_valid($('input[name="' + window.secondAddress + '_full_address"]')[0], undefined);
								}
							}
						}
					}
				}
			}

			// kontrola hesla
			isPasswordOK = is_password_valid(form);
			valid = valid && isPasswordOK;

			// kontrola dopravy
			if ($('input[name=shipping_id]').length > 0) {
				var ship_id = $('input[name=shipping_id]:checked');
				if (ship_id.length === 0) {
					valid = false;
					$('.js-shipping-error').show().addClass('is-invalid');
				} else {
					var value_ship_choice = $(":input[name=" + ship_id.val() + "_choice_shipping_id]");
					if (value_ship_choice.length > 0 && (typeof value_ship_choice.val() === 'undefined' || value_ship_choice.val() === '')) {
						valid = false;
						$('.js-shipping-error').show().addClass('is-invalid');
					} else {
						$('.js-shipping-error').hide().removeClass('is-invalid');
					}
				}
			}

			// kontrola platby
			if ($('input[name=payment_id]').length > 0) {
				if ($('input[name=payment_id]:checked').length === 0) {
					valid = false;
					$('.js-payment-error').show().addClass('is-invalid');
					window.parent.postMessage("hideLoader", "*");
				} else {
					$('.js-payment-error').hide().removeClass('is-invalid');
				}
			}

			if (!valid) {
				var first = $('.is-invalid:first')[0];
				if (!$(first).is(":visible")) {
					/*if ($('input', first).hasClass('js--checkbox-alert')) {
						//$('.js--tos_detail').collapse('show');
					} else {*/
					$('.js--toggle-shpping-data-form').trigger('click');
					$('#formdata').collapse('hide');
					$('#formdataedit').collapse('show');
					/*}*/
				}
				scrollToElement(first, -70);
				event.preventDefault();
			} else {
				// tohle je zbytečné - prověřit
				var email = document.querySelector('input[name=email_without_registration]');
				unmark_invalid(email);
				if (form.classList.contains("js-use-overlay")) {
					showOrderOverlay();
				}
			}
		} catch (err) {
			console.error("Chyba vyhodnocení formulare", err);
			event.preventDefault();
			return false;
		}

		valid = false;
		return valid;
	}
};

var initialize_quantity_input = function (input) {
	var buttonUp = input.parentNode.querySelector(".quantity-up");
	var buttonDown = input.parentNode.querySelector(".quantity-down");
	var input_route = input.dataset.route;
	if (!(buttonUp && buttonDown)) {
		return;
	}
	var min = parseInt(input.getAttribute("min"));
	var max = parseInt(input.getAttribute("max"));

	buttonUp.addEventListener("click", function () {
		var old_value = parseFloat(input.value);
		if (old_value < max || isNaN(max)) {
			input.value = old_value + 1;
			if (input_route === "cart") {
				triggerEvent(input, "change");
			}
		} else {
			console.log("Pokus zvýšit početnad maximum: ", old_value + 1, ">", max);
		}
		return true;
	});

	buttonDown.addEventListener("click", function () {
		var old_value = parseFloat(input.value);
		if (old_value > min) {
			input.value = old_value - 1;
			if (input_route === "cart") {
				triggerEvent(input, "change");
			}
		} else {
			console.log("Pokus snížit počet pod minimum: ", old_value + 1, "<", min);
		}
		return true;
	});

	input.addEventListener("change", change_cart_row);
};

function cart_dom_content_loaded(event) {
	var quantity_inputs = document.querySelectorAll("input[type=number].quantity-counter");
	if (quantity_inputs) {
		[].forEach.call(quantity_inputs, function (item) {
			initialize_quantity_input(item);
		});
	}

	var submit_form = document.forms.payment_form;
	if (submit_form) {
		submit_form.addEventListener("submit", check_order_before_submit);
	}

	var main_elem = $('section[role=main]');
	if (typeof (main_elem.data('login')) !== 'undefined' && main_elem.data('login')) {
		var modal_elem = $('#modal_login');
		if (modal_elem.is(":visible")) {
			modal_elem.modal('show');
		}
	}

	var add_voucher_form = document.forms.add_voucher;
	if (add_voucher_form) {
		add_voucher_form.addEventListener("submit", add_voucher);
		var params = new URLSearchParams(window.location.search);
		var voucher_code = params.get('voucher_code');
		if (typeof voucher_code !== "undefined" && voucher_code !== null) {
			// pokud je v GET parametru voucher_code, vyzkousej ho pridat do kosiku
			$('input[name="voucher_code"]').val(voucher_code);
			$(add_voucher_form).find('button[type="submit"]').trigger('click');
			return false;
		}
	}
}

document.addEventListener("DOMContentLoaded", cart_dom_content_loaded);

var is_address_filled = function (address_id, openEditIfEmpty) {
	var address = 0;
	$.each($('.js--' + address_id + '_address span[class^="address__label--"]'), function (i, field) {
		address += field.innerHTML !== '' ? 1 : 0;
	});

	if (address === 0 && openEditIfEmpty) {
		$('#modal_edit_' + address_id + '_address').modal('show');
	}

	return address;
};

function bind_payment_credit() {
	$.each($('input[name="use_credits"]'), function (index) {
		$(this).change(function () {
			var context = $(this);
			var is_enabled = context.is(":checked");
			actualize_payment_credit_call(is_enabled);
		})
	});
}

function actualize_payment_credit_call(is_enabled) {
	$.ajax({
		isLocal: true,
		method: "POST",
		dataType: "json",
		url: "/actualize-credits-usage",
		data: {
			"is_enabled": is_enabled,
		},
		beforeSend: function () {
			loaderShow();
		},
		complete: function () {
			loaderHide();
		},
		success: function (response) {
			if (response["status"] === 500) {
				console.log(response["message"]);
			} else {
				actualize_shipping_payment("credits", response["mini_checkout"], response["pricing"], response["payment_options"], response["shipping_options"]);
			}
		}
	});
}

function bind_payment_methods(klub) {
	if (klub === true) {
		$.ajax({
			isLocal: true,
			method: "POST",
			dataType: "json",
			url: "/actualize-payment-method",
			data: {
				"payment_id": "knihacz_invoice"
			},
			success: function (response) {
				if (response["status"] === 500) {
					console.log(response["message"]);
				} else {
					// klub to má jinak .. tak je to asi správně..
					// console.log("sending", response.payment, " as minicheckout")
					actualize_shipping_payment("payment", response["payment"], response["pricing"]);
				}
			}
		});
	} else {
		$.each($('input[name="payment_id"]'), function () {
			$(this).change(function () {
				if ($('input[name="payment_id"]:checked').length > 0) {
					var payment_id = $('input[name="payment_id"]:checked').val();
					$.ajax({
						isLocal: true,
						method: "POST",
						dataType: "json",
						url: "/actualize-payment-method",
						data: {
							"payment_id": payment_id
						},
						beforeSend: function () {
							loaderShow();
						},
						complete: function () {
							loaderHide();
						},
						success: function (response) {
							if (response["status"] === 500) {
								console.log(response["message"]);
							} else {
								actualize_shipping_payment("payment", response["mini_checkout"], response["pricing"], response["payment_options"], response["shipping_options"]);
							}
							// schovat payu skupinu pokud nejsem payu
							// to nasledujici je startswith
							if (payment_id.substr(0, 5) !== 'payu_') {
								$('input[name=payu_buttons]').prop("checked", false);
								$('#payu_payments').collapse("hide");
							}
						}
					});
				}
			})
		});
	}
}

function bind_payment_methods_events() {
	$.each($('input[name="payment_id"]'), function () {
		$(this).change(function () {
			if ($('input[name="payment_id"]:checked').length > 0) {
				var payment_id = $('input[name="payment_id"]:checked').val();
				$.ajax({
					isLocal: true,
					method: "POST",
					dataType: "json",
					url: "/actualize-payment-method-events",
					data: {
						"payment_id": payment_id
					},
					beforeSend: function () {
						loaderShow();
					},
					complete: function () {
						loaderHide();
					},
					success: function (response) {
						if (response["status"] === 500) {
							console.log(response["message"]);
						} else {
							actualize_shipping_payment("payment", response["mini_checkout"], response["pricing"], response["payment_options"], response["shipping_options"]);
						}
						// schovat payu skupinu pokud nejsem payu
						// to nasledujici je startswith
						if (payment_id.substr(0, 5) !== 'payu_') {
							$('input[name=payu_buttons]').prop("checked", false);
							$('#payu_payments').collapse("hide");
						}
					}
				});
			}
		})
	});
}

function actualize_shipping_method_call(ship_id, choice) {
	$.ajax({
		isLocal: true,
		method: "POST",
		dataType: "json",
		url: "/actualize-shipping-method",
		data: {
			"shipping_id": ship_id,
			"shipping_choice_id": choice
		},
		beforeSend: function () {
			loaderShow();
		},
		complete: function () {
			loaderHide();
		},
		success: function (response) {
			if (response["status"] === 500) {
				console.log(response["message"]);
			} else {
				actualize_shipping_payment("shipping", response["mini_checkout"], response["pricing"], response["payment_options"], response["shipping_options"]);
			}
		}
	});
}

function actualize_shipping_method_events_call(ship_id, choice) {
	$.ajax({
		isLocal: true,
		method: "POST",
		dataType: "json",
		url: "/actualize-shipping-method-events",
		data: {
			"shipping_id": ship_id,
			"shipping_choice_id": choice
		},
		beforeSend: function () {
			loaderShow();
		},
		complete: function () {
			loaderHide();
		},
		success: function (response) {
			if (response["status"] === 500) {
				console.log(response["message"]);
			} else {
				actualize_shipping_payment("shipping", response["mini_checkout"], response["pricing"], response["payment_options"], response["shipping_options"]);
			}
		}
	});
}

function bind_shipping_methods(klub) {
	if (klub === true) {
		$.ajax({
			isLocal: true,
			method: "POST",
			dataType: "json",
			url: "/actualize-shipping-method",
			data: {
				"shipping_id": "klub_kniha_balik_do_ruky"
			},
			success: function (response) {
				if (response["status"] === 500) {
					console.log(response["message"]);
				} else {
					actualize_shipping_payment("shipping", response["mini_checkout"], response["pricing"], response["payment_options"], response["shipping_options"]);
				}
			}
		});
	} else {
		$.each($('input[name="shipping_id"]'), function (index) {
			$(this).change(function () {
				var context = $(this);
				var ship_id = context.val();
				var choice = $(":input[name=" + ship_id + "_choice_shipping_id]");
				choice = choice ? choice.val() : null;
				actualize_shipping_method_call(ship_id, choice);
			})
		});
		$.each($(':input[name$="_choice_shipping_id"]'), function (index) {
			bind_shipping_choice($(this));
		});
	}
}

function bind_shipping_methods_events() {
	$.each($('input[name="shipping_id"]'), function (index) {
		$(this).change(function () {
			var context = $(this);
			var ship_id = context.val();
			var choice = $(":input[name=" + ship_id + "_choice_shipping_id]");
			choice = choice ? choice.val() : null;
			actualize_shipping_method_events_call(ship_id, choice);
		})
	});
	$.each($(':input[name$="_choice_shipping_id"]'), function (index) {
		bind_shipping_choice($(this));
	});
}

function bind_shipping_choice(el) {
	el.change(function () {
		var context = $(this);
		ship_id = context.attr("name");
		ship_id = ship_id.substring(0, ship_id.length - 19);
		var selected = $(
			'input[name="shipping_id"][value="' + ship_id + '"]:checked'
		);
		if (!selected) {
			return;
		}
		var choice = context.val();
		actualize_shipping_method_call(ship_id, choice);
	});
}

function frmt_price(price) {
	price = price.replace(".00", "").replace(".", ",");
	return price;
}

function actualize_shipping_payment(type, mini_checkout, pricing, payment_options, shipping_options) {
	if (typeof pricing == 'undefined') pricing = null;
	if (typeof payment_options == 'undefined') payment_options = null;
	if (typeof shipping_options == 'undefined') shipping_options = null;
	if (pricing !== null) {
		var payment_netto = ((pricing["payment_price"]["netto"]) !== "undefined") ? pricing["payment_price"]["netto"] : 0;
		var shipping_netto = ((pricing["shipping_price"]["netto"]) !== "undefined") ? pricing["shipping_price"]["netto"] : 0;
		var packing_netto = ((pricing["packing_price"]["netto"]) !== "undefined") ? pricing["packing_price"]["netto"] : 0;
		var items_netto = ((pricing["discounted_netto"]) !== "undefined") ? pricing["discounted_netto"] : 0;
		var payment_brutto = ((pricing["payment_price"]["brutto"]) !== "undefined") ? pricing["payment_price"]["brutto"] : 0;
		var shipping_brutto = ((pricing["shipping_price"]["brutto"]) !== "undefined") ? pricing["shipping_price"]["brutto"] : 0;
		var packing_brutto = ((pricing["packing_price"]["brutto"]) !== "undefined") ? pricing["packing_price"]["brutto"] : 0;
		var items_brutto = ((pricing["to_pay_for_cart"]) !== "undefined") ? pricing["to_pay_for_cart"] : 0;
		var netto = (payment_netto + shipping_netto + packing_netto + items_netto).toFixed(
			typeof cart_payment_format_numbers === 'undefined' ? 2 : cart_payment_format_numbers);
		var brutto = (payment_brutto + shipping_brutto + packing_brutto + items_brutto).toFixed(
			typeof cart_payment_format_numbers === 'undefined' ? 2 : cart_payment_format_numbers);
		var sum_without_vat = $(".js-minicheckout-netto");
		var sum_with_vat = $(".js-minicheckout-brutto");

		/* podle platby kredity musím skrýt měnu a zobrazit kredity */
		//var currency_credit = $(".row-sum__with-vat__currency.currency--credit");
		//var currency_money = $(".row-sum__with-vat__currency.currency--money");
		//if (currency_credit && currency_money){
		//    /* až půjde doplatek tak se to tu bude muset upravit */
		//    if (pricing.used_credits_discount){
		//        currency_credit.show();
		//        currency_money.hide();
		//    } else {
		//        currency_credit.hide();
		//        currency_money.show();
		//    }
		//}

		netto = frmt_price(netto);
		brutto = frmt_price(brutto);

		sum_without_vat.text(netto);
		sum_with_vat.text(brutto);
	}

	if (payment_options !== null) {
		$('.js-payment_options').html(payment_options);
		$('.label--payment [data-toggle="tooltip"]').tooltip();
		bind_payment_methods(false);
		bind_payment_credit(false);
		handleActivePayment();
	}
	if (shipping_options !== null) {
		$('.js-shipping_options').html(shipping_options);
		$('.label--payment [data-toggle="tooltip"]').tooltip();
		bind_shipping_methods(false);
		// vyřešit binding map a podobný věcí pro podobně ...
		// tady je posiible fail na shippingy po výběru paymentu
		handleActiveShipping();
	}

	var mini_checkout_classes = ['cart_payment_only', 'cart_payment', 'event_cart_payment'];
	$.each(mini_checkout_classes, function (key, value) {
		$('.js--checkout--mini.' + value + ' tbody:last-child tr.shipping').remove();
		$('.js--checkout--mini.' + value + ' tbody:last-child tr.payment').remove();
		if ($('.js--checkout--mini.' + value + ' tbody:last-child tr.vouchers').length > 0) {
			$('.js--checkout--mini.' + value + ' tbody:last-child tr.vouchers').remove();
		}
		$('.js--checkout--mini.' + value + ' tbody:last-child').prepend(mini_checkout);
		$('.label--payment [data-toggle="tooltip"]').tooltip();
	});
}

function loaderShow() {
	$('tr.payment td').css('opacity', 0.3);
	$('tr.shipping td').css('opacity', 0.3);
	//$('tr.payment').css('background-color', '#eee');
	//$('tr.shipping').css('background-color', '#eee');
	$('#loader').show();
}

function loaderHide() {
	$('#loader').hide();
	$('tr.payment td').css('opacity', 1);
	$('tr.shipping td').css('opacity', 1);
	//$('tr.payment').css('background-color', '#fafafa');
	//$('tr.shipping').css('background-color', '#fafafa');
}

function resetErrorsCollapsed() {
	$('#collapse_company').on('hidden.bs.collapse', function (ev) {
		unmark_invalid(document.querySelector('input[name=facturation_ic]'));
	});

	$('#collapse_delivery').on('hidden.bs.collapse', function (ev) {
		unmark_invalid(document.querySelector('input[name=facturation_name]'));
		unmark_invalid(document.querySelector('input[name=facturation_surname]'));
		unmark_invalid(document.querySelector('input[name=facturation_street]'));
		unmark_invalid(document.querySelector('input[name=facturation_city]'));
		unmark_invalid(document.querySelector('input[name=facturation_zip]'));
	});

	$('#collapse_register').on('hidden.bs.collapse', function (ev) {
		unmark_invalid(document.querySelector('input[name=password_pass]'));
		unmark_invalid(document.querySelector('input[name=password_again]'));
	});
}

function bindStopOnError(err) {
	cont_button = $(".js--continue-button");
	if (cont_button) {
		cont_button.on('click', function (ev) {
			if ($(this).hasClass('js-button-warning-' + err)) {
				ev.preventDefault();
				var errDiv = $('.js-invisible-' + err);
				errDiv.show();
				if (errDiv[0]) {
					$('html, body').animate({
						scrollTop: $(errDiv[0]).offset().top - 20
					}, 1000);
				}
				return false;
			}
			return true;
		});
	}
}
function initializeScroolToTopWarnings() {
	$(".js-scroll-to-warning").click(function () {
		var context = $(this);
		var err = context.data("code");
		if (!err) {
			return
		}
		var errDiv = $('.js-invisible-' + err);
		errDiv.show();
		if (errDiv[0]) {
			$('html, body').animate({
				scrollTop: $(errDiv[0]).offset().top - 20
			}, 1000);
		}

	});
}

function initializeAlreadyBuyedButton() {
	bindStopOnError("501");
	bindStopOnError("505");
}

$(function () {
	ensureAddressTypes();

	var first_addr = $("#modal_edit_" + window.firstAddress + "_address");
	var second_addr = $("#modal_edit_" + window.secondAddress + "_address");


	if (first_addr.length > 0 || second_addr.length > 0) {
		is_address_filled(window.firstAddress, true);
	}

	second_addr.on("hide.bs.modal", function () {
		var is_filled = is_address_filled(window.secondAddress);

		if (is_filled === 0) {
			$('.js--block--' + window.secondAddress + '_address').addClass('d-none');
			$('#edit_' + window.secondAddress + '_address').prop('checked', false);
		}
	});

	if ($(".js--checkout--mini.cart_payment").length > 0 || $(".js--checkout--mini.cart_payment_only").length > 0) {
		bind_shipping_methods(false);
		bind_payment_methods(false);
		bind_payment_credit(false);
		bind_unlogged_user_changed_country();
	} else if ($(".js--checkout--mini.event_cart_payment").length > 0) {
		bind_shipping_methods_events();
		bind_payment_methods_events();
	} else if ($(".js--checkout--mini.klub").length > 0) {
		bind_shipping_methods(true);
		// bind_payment_methods(true);
	}
	else {
		loaderHide();
	}

	resetErrorsCollapsed();
});

function unlogged_address_changed() {
	ensureAddressTypes();
	var mainForm = $("#payment_form");
	var firstCountry = mainForm.find("select[name=" + window.firstAddress + "_country]").val();
	var secondCountry = mainForm.find("select[name=" + window.secondAddress + "_country]").val();
	var secondCoutryFilled = $('#edit_' + window.secondAddress + '_address').is(':checked');
	var data = {};
	data[window.firstAddress + "_country"] = firstCountry;
	data[window.secondAddress + "_country"] = secondCountry;
	data["second_address_filled"] = secondCoutryFilled;
	$.ajax({
		isLocal: true,
		method: "POST",
		dataType: "json",
		url: "/actualize-cart-on-address-change",
		data: data,
		success: function (response) {
			if (response["status"] === 500) {
				console.log(response["message"]);
			} else {
				actualize_shipping_payment("address-logged", response["mini_checkout"], response["pricing"], response["payment_options"], response["shipping_options"]);
			}
		}
	});
	return true;
}

function bind_unlogged_user_changed_country() {
	var mainForm = $("#payment_form");
	if (!mainForm) {
		return;
	}
	ensureAddressTypes();
	var firstCountry = mainForm.find("select[name=" + window.firstAddress + "_country]");
	if (firstCountry) {
		firstCountry.on("change", function () {
			unlogged_address_changed();
		});
		var secondCountry = mainForm.find("select[name=" + window.secondAddress + "_country]");
		if (secondCountry) {
			secondCountry.on("change", function () {
				unlogged_address_changed();
			});
		}
	}
}

function voucherBindResetUserEmail() {
	$('.modal-footer .row div a.js-remove-cart-user').on('click', function (e) {
		$.ajax({
			isLocal: true,
			method: "POST",
			dataType: "json",
			url: "/ajax/reset_user_email_cart",
			success: function (res) {
				if (res.status === 200) {
					window.location.href = res.response;
				} else {
					console.log(res.status_message);
				}
			}
		});
	});
}

function createVoucherModal(data) {
	var buttons = [];
	for (var i = 0; i < data.button.length; ++i) {
		butt = data.button[i];

		var dismiss = '';
		if (butt.dismiss) {
			dismiss = ' data-dismiss="modal"';
		}
		buttons.push(
			'<a' + dismiss + ' class="' + butt.addclass + '"><span>' + butt.text + '</span></a>'
		);
	}

	var modalTpl =
		'<div id="customModal" class="modal modal--' + data.result + ' fade">' +
		'  <div class="modal-dialog modal-wide">' +
		'    <div class="modal-content">' +
		'      <div class="modal-header">' +
		'        <button type="button" class="close" data-dismiss="modal">&times;</button>' +
		'        <h4 class="modal-title">' + data.title + '</h4>' +
		'      </div>' +
		'      <div class="modal-body">' + data.text + '</div>' +
		'      <div class="modal-footer">' +
		'        <div class="row align-items-center text-sm-left text-center">' +
		'          <div class="col-sm-auto text-sm-right">' + buttons.join('</div><div class="col-sm text-sm-right">') + '</div>' +
		'        </div>' +
		'      </div>' +
		'    </div>' +
		'  </div>' +
		'</div>';

	$(modalTpl).modal();
}


// checkout fixed submit button on scroll
function handleCheckoutFixedButton() {
	var checkoutFixedButton = document.querySelector('.js-fixed-button');
	if (checkoutFixedButton) {
		var targetElement = document.querySelector('.js-fixed-button-target');
		if (targetElement) {
			function checkButtonPosition() {
				var targetOffset = targetElement.getBoundingClientRect().top + window.scrollY + 150; // 200 = cca height of fixed button box
				var viewHeight = window.innerHeight;
				var scrollTop = window.scrollY + viewHeight;
				if (scrollTop >= targetOffset) {
					checkoutFixedButton.classList.add('is--relative');
				} else {
					checkoutFixedButton.classList.remove('is--relative');
				}
			}

			// Spustit při načtení stránky
			checkButtonPosition();

			// Spustit při scrollování
			window.addEventListener('scroll', checkButtonPosition);
		}
	}
}



$(document).ready(function () {
	handleCheckoutFixedButton();

	if ($('main').data('vouchermodal')) {
		createVoucherModal($('main').data('vouchermodal'))
		setTimeout(function (e) {
			voucherBindResetUserEmail();
		}, 1000);
	}

	initializeAlreadyBuyedButton();
	initializeScroolToTopWarnings();
});

function cart_key(ident, content_type, part) {
	if (!part) {
		part = ident;
	}
	return ident + "*/*" + content_type + "*/*" + part;
}

var handleAddToCart = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var provider = tgt.dataset.provider;
	var isEvent = $(tgt).data('is_event');
	var ident = $(tgt).data('ident');
	var part = $(tgt).data('part');
	var contentType = $(tgt).data('c_type');
	var variant = $(tgt).data('variant');
	var input = $('input[name="counter"][data-key="' + tgt.dataset.key + '"]:first');
	var extend_info = $(tgt).data("extend_info");
	if (variant) {
		if (!extend_info) {
			extend_info = { "variant": variant };
		}
		else {
			extend_info['variant'] = variant;
		}
	}
	var real_count = 0;
	if (input.length > 0 && parseInt(tgt.dataset.multipliable) === 1) {
		var count = parseInt(input.val());
		var count_in_cart = parseInt(input.data("in_cart"));
		var count_storage = parseInt(input.data("storage_count"));
		real_count = count + count_in_cart;
		input.data("in_cart", real_count);

		if (!isNaN(count_storage) && real_count > count_storage) {
			real_count = count_storage;
		}
	} else {
		real_count = 1;
	}

	var refresh = tgt.dataset.refresh;

	if (tgt.classList.contains("in-cart")) {
		// už to v košíku je dej to pryč!!!!!
		real_count = 0;
	}

	if (tgt.classList.contains("gift-not-selected")) {
		return false;
	}

	// Ostranim jine predplatne tehoz media a typu, pokud pridavam - pokud odebiram, je mi to jedno
	if (provider == 'vydani' && contentType.indexOf('_prepaid') > 0 && real_count > 0) {
		let prepaid_box = $(tgt).closest('div.detail__prepaid');
		multi_items = [];
		if (prepaid_box.length > 0) {
			in_cart_prepaids = $('button.js--button-prepaid-buy.in-cart', prepaid_box);
			in_cart_prepaids.each(function () {
				multi_items.push(
					create_cart_item(
						$(this).data('provider'),
						$(this).data('ident'),
						$(this).data('c_type'),
						$(this).data('part'),
						0,
						$(this).data('extend_info')
					)
				);
			});
		}
		multi_items.push(create_cart_item(provider, ident, contentType, part, real_count, extend_info))
		addToCartMultiple(multi_items, false, null, true);
	}
	else {
		addToCart(create_cart_item(provider, ident, contentType, part, real_count, extend_info), refresh, isEvent == '1');
	}

	return false;
};

var handleRemoveFromCart = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var provider = tgt.dataset.provider;
	var ident = $(tgt).data('ident');
	var part = $(tgt).data('part');
	var contentType = $(tgt).data('c_type');
	var variant = $(tgt).data('variant');
	var extend_info = null;
	if (variant) {
		if (!extend_info) {
			extend_info = { "variant": variant };
		}
		else {
			extend_info['variant'] = variant;
		}
	}
	var refresh = tgt.dataset.refresh;
	var count = 0;

	addToCart(create_cart_item(provider, ident, contentType, part, count, extend_info), refresh);

	return false;
};

var handleChangeCType = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var provider = $(tgt).find('option:selected').data('provider');
	var ident = $(tgt).find('option:selected').data('ident');
	var part = $(tgt).find('option:selected').data('part');
	var contentTypeOld = $(tgt).find('option:selected').data('c_type_old');
	var contentType = $(tgt).find('option:selected').val();
	var refresh = $(tgt).find('option:selected').data('refresh');
	var extend_info = $(tgt).find('option:selected').data('extend_info');
	var silent = $(tgt).find('option:selected').data('silent');
	var price = $(tgt).find('option:selected').data('price');
	var special_action = {
		"action": "_change_ctype",
		"new_value": contentType,
		"old_value": contentTypeOld
	};
	var count = 1;

	// pridani noveho c_type zbozi a odstraneni puvodni
	addToCart(create_cart_item(provider, ident, contentType, part, count, extend_info), refresh, silent, special_action);

	// update ceny v radku v kosiku
	$(tgt).closest('tr').find('td.td__price').find('.js--price--full_brutto').html(price);

	return false;
};

var addToCartMultiple = function (items, cleanup, callback, modal) {
	var data = {
		"items_to_add": items,
		"cleanup": cleanup,
		"modal": modal
	};
	$.ajax({
		url: "/ajax/change_cart_multiple",
		method: "POST",
		data: JSON.stringify(data),
		contentType: "application/json",
		async: true,
		beforeSend: function () {
			document.body.classList.add('loading');
		},
		success: function (response) {
			if (modal) {
				var req_data = response;
				process_change_cart_factory(req_data, items[items.length - 1], false, !modal, null, callback, key, true);
			} else if (callback) {
				callback();
			} else {
				window.location.reload();
			}
		},
		complete: function () {
			document.body.classList.remove('loading');
		},
		fail: function (response) {
			console.log(response);
		}
	});
	return false;
};

var addToCart = function (changed_item, refresh, silent, special_action, success_callback) {
	if (!changed_item) {
		return false;
	}

	if (!special_action) {
		special_action = "";
	} else {
		special_action = "/" + special_action.action + "/" + special_action.old_value;
	}


	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.OPENED) {
			document.body.classList.add('loading');
			// odstraneni tlacitka behem nacitani, aby nedochazelo k dvojitemu kliknuti
			var remove_buttons = document.querySelectorAll("button.remove-from-cart");
			if (remove_buttons) {
				$(remove_buttons).each(function () {
					$(this).hide();
				});
			}
		} else if (req.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
			document.body.classList.remove('loading');
		} else if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				process_change_cart_factory(req_data, changed_item, refresh, silent, special_action, success_callback, key, true);
			}
			else {
				alert("Chyba");
			}
		}
	};

	req.open("POST", "/ajax/change_cart" + special_action, true);
	req.setRequestHeader("Content-type", "application/json");
	req.send(JSON.stringify(changed_item));
	return false;
};

/*
 * #72979 - košík neukládá informaci o stavu při vrácení se zpět
 * roztrhnuti funkcionality kvuli ajax/get_cart pro task vyse
 */

function switchCartButtonToBuy(item) {
	item.classList.remove("in-cart");
	item.dataset.trackClick = item.dataset.trackClickAdd;
	item.dataset.trackMeiroClick = item.dataset.trackMeiroClickAdd;

	item.innerHTML = JSON.parse(item.dataset.buy_text);
}

function switchCartButtonToInCart(item) {
	var multipliable = parseInt(item.dataset.multipliable);
	item.innerHTML = JSON.parse(item.dataset.in_cart_text);
	if (multipliable === 0) {
		item.classList.add("in-cart");
		item.dataset.trackClick = item.dataset.trackClickRemove;
		item.dataset.trackMeiroClick = item.dataset.trackMeiroClickRemove;
	} else {

	}
}

function process_change_cart_factory(
	req_data, changed_item, refresh, silent,
	special_action, success_callback, key, update_cart
) {
	if (req_data) {
		if (req_data["status"] === 200) {
			if (success_callback) {
				if (typeof success_callback !== "undefined") {
					success_callback(req_data);
				}
			}
			if (refresh) {
				location = location;
				window.location.reload();
			} else {
				if (typeof processChangeCartFactoryPortalPreFunction !== "undefined") {
					try {
						processChangeCartFactoryPortalPreFunction(req_data.response, changed_item);
					} catch (e) {
						console.error("Error", e, "while processing", processChangeCartFactoryPortalPreFunction);
					}
				}

				var buy_buttons = [];
				if (changed_item) {
					var key = cart_key(changed_item["parent_ident"], changed_item["content_type"], changed_item["ident"] || changed_item["parent_ident"]);
					buy_buttons = document.querySelectorAll("button.add-to-cart[data-key=\"" + key + "\"]");
				} else {
					var selectors = [];
					for (var i = 0; i < req_data.response.items.length; ++i) {
						var item = req_data.response.items[i];
						var key = cart_key(item["parent_ident"], item["c_type"], item["ident"] || item["parent_ident"]);
						selectors.push("button.add-to-cart[data-key=\"" + key + "\"]");
					}
					if (selectors.length) {
						buy_buttons = document.querySelectorAll(selectors.join());
					}
				}

				updateBadges(req_data.response);

				if (update_cart) {
					updateBasketSummary(req_data.response);
				}

				if (changed_item && changed_item["count"] === 0) {
					[].forEach.call(buy_buttons, switchCartButtonToBuy);
					var remove_blocks = document.querySelectorAll(".remove-from-cart-block[data-key=\"" + key + "\"]");
					[].forEach.call(remove_blocks, function (item) {
						item.parentNode.removeChild(item);
					});
				} else {
					if (buy_buttons) {
						if (update_cart) {
							try {
								if (window.global_google_analytics) {
									ga('tracker_1.ec:addProduct', {
										'id': changed_item["parent_ident"],
										'name': buy_buttons[0].getAttribute("data-title"),
										'category': buy_buttons[0].getAttribute("data-categories"),
										'variant': changed_item["content_type"],
										'price': buy_buttons[0].getAttribute("data-price"),
										'quantity': changed_item["count"]
									});
								}
							} catch (e) { }
						}

						[].forEach.call(buy_buttons, function (item) {
							var multipliable = parseInt(item.dataset.multipliable);
							switchCartButtonToInCart(item);
							if (multipliable === 0) {
								// if (update_cart) {
								// 	if (typeof gtmInit === "function" && typeof gtmInit !== undefined) {
								// 		gtmInit();
								// 	}
								// }
							} else {
								if (update_cart) {
									var counters = $('input[name="counter"][data-key="' + key + '"]');
									var all_stock_in_cart = false;
									if (counters.length) {
										var itm_count = changed_item['count'];
										[].forEach.call(counters, function (counter) {
											counter.dataset.in_cart = itm_count;
											counter.value = 1;
										});
										var display_counters = $('.item_cart_count[data-key="' + key + '"]');
										[].forEach.call(display_counters, function (d_counter) {
											d_counter.innerHTML = itm_count;
										});
										var max = parseInt(counters[0].max);
										if (!isNaN(max) && itm_count >= max) {
											all_stock_in_cart = true;
										}
									}
									if (all_stock_in_cart) {
										item.innerHTML = JSON.parse(item.dataset.all_stock_text);
										$(item).removeClass('button--primary').addClass('button--grey').prop('disabled', true);
										$('.detail__button .counter.nowrap').remove();
									}
								}  // if update_cart
							}  // if multiplable
						}); // foreach buy_button
					} // if buy_buttons
				} // endif changed item & count == 0


				/* if (update_cart) { */
				updateBasketPrice(req_data.response);
				/* } */
			}
		}
		if (update_cart) {
			if ((!silent) && (!refresh)) {
				showModal(req_data["modal"]);
				$('.modal-backdrop:not(:last)').remove();
			}
		}
		var asyncLoaderClass = ".js__async_loader__related";
		if ($(asyncLoaderClass).length) {
			$(asyncLoaderClass).each(initializeAsyncLoader);
		}
	} else {
		alert("Chyba");
	}
}

function switch_prepaid(ev) {
	var buy_btn = $('.button.add-to-cart.js-detail-buy-button');
	if (buy_btn.hasClass('in-cart')) {
		// task http://red.atspraha.cz/issues/42547
		var provider = buy_btn.data('provider');
		var ident = buy_btn.data('ident');
		var part = buy_btn.data('part');
		var contentType = buy_btn.data('c_type');
		var refresh = false;
		var silent = true;
		// tohle odebere to co tam je
		addToCart(create_cart_item(provider, ident, contentType, part, 0), refresh, silent);
		switchCartButtonToBuy(buy_btn);
		// původní kód kdy to měnit nelze
		// ev.preventDefault();
		// return false;
	}
	var target = ev.currentTarget;

	buy_btn.data('extend_info', '');

	var copyKeys = ["ident", "part", "multipliable"]
	copyKeys.forEach(function (copyKey) {
		buy_btn.data(copyKey, $(target).data(copyKey));
	});
	var copyIfFilledKeys = ["price", "title", "categories", "category_ids", "brand"];
	var copyKeyVal;
	copyIfFilledKeys.forEach(function (copyKey) {
		copyKeyVal = $(target).data(copyKey);

		if (typeof copyKeyVal !== 'undefined') {
			buy_btn.data(copyKey, copyKeyVal);
		}
	});

	buy_btn.data('key', cart_key($(target).data('ident'), target.dataset.content_type, ""));
	buy_btn.data('c_type', $(target).data('content_type'));
	var js_details = $('.js-detail-price');
	for (var i = 0; i < js_details.length; ++i) {
		$(js_details[i]).html($(target).data('price'));
	}
	return true;
}

function bindCartButtons() {
	var buy_buttons = document.querySelectorAll("button.add-to-cart");
	if (buy_buttons) {
		[].forEach.call(buy_buttons, function (item) {
			item.addEventListener("click", handleAddToCart);
		});
	}
	var remove_buttons = document.querySelectorAll("button.remove-from-cart");
	if (remove_buttons) {
		[].forEach.call(remove_buttons, function (item) {
			item.addEventListener("click", handleRemoveFromCart);
		});
	}
	var prepaid_switcher = document.querySelectorAll(".js-prepaid-switcher input[name='prepaid']");
	if (prepaid_switcher) {
		[].forEach.call(prepaid_switcher, function (item) {
			item.addEventListener("click", switch_prepaid);
		});
	}
	var change_ctype_select = document.querySelectorAll("select.js-change-ctype");
	if (change_ctype_select) {
		[].forEach.call(change_ctype_select, function (item) {
			item.addEventListener("change", handleChangeCType);
		});
	}
}

document.addEventListener("DOMContentLoaded", function (ev) {
	bindCartButtons();
});
